module.exports = __webpack_public_path__ + "static/media/Medium.0b77b65c.svg";